import * as React from 'react';
import { FotoramaContainer } from '../../containers/fotorama';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var FlatGallery = function FlatGallery(_ref) {
  var flat = _ref.flat;
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    id: "photos",
    children: /*#__PURE__*/_jsx(FotoramaContainer, {
      flat: flat
    })
  });
};